<template>
    <VJoyDialog
        ref="dialogRef"
        :pattern-brand="true"
        :confirm-text="$t('search.service-level.profile-views.upgrade-dialog.cta')"
        :cancel-text="$t('search.service-level.profile-views.upgrade-dialog.cancel')"
        data-testid="profile-views-upgrade-dialog"
        @dialog:confirm="goToUpgradePage()"
    >
        <template #dialog-header>
            {{ $t('search.service-level.profile-views.upgrade-dialog.title') }}
        </template>
        <template #dialog-subheader>
            {{ $t('search.service-level.profile-views.upgrade-dialog.subtitle') }}
        </template>
        <template #dialog-body>
            <MaltImg src="/hopsearch/service-levels/upgrade-illustration.svg" alt="Upgrade illustration" width="200" />
        </template>
    </VJoyDialog>
</template>

<script setup lang="ts">
    import {onMounted, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {useRoute} from 'vue-router';
    import {MaltImg} from '#components';
    import {navigateTo, useDataTracking} from '#imports';
    import {VJoyDialog} from '@maltjoy/core-vue';
    import {useUserInfo} from '~/composables/useUserInfo';
    import {useProfileViews} from './useProfileViews';
    import {useSearchUrlStore} from '../stores/search-url.store';

    const dialogRef = ref<InstanceType<typeof VJoyDialog> | null>(null);

    const route = useRoute();
    const searchUrlStore = useSearchUrlStore();
    const {searchUrlParams} = storeToRefs(searchUrlStore);
    const {track} = useDataTracking();
    const {serviceLevel} = useUserInfo();
    const {shouldUpgrade, profileViewsStatus} = useProfileViews();

    function openDialog() {
        dialogRef.value?.show();
        track('profile_views_limit_reached', {
            threshold_reached: profileViewsStatus.value?.limit,
            current_service_level: serviceLevel.value,
        });
    }

    function goToUpgradePage() {
        navigateTo(
            {
                path: '/client-settings/service-level',
                query: {
                    pageSource: 'blocker',
                    sourceComponent: 'search_profile_views_upgrade_dialog',
                    successRedirectPath: searchUrlParams.value.rejectedUrl,
                    dropRedirectPath: route.fullPath,
                },
            },
            {external: true},
        );
    }

    onMounted(() => {
        if (searchUrlParams.value.rejectReason === 'profile-views-limit' && shouldUpgrade.value) {
            openDialog();
        }
    });
</script>
